import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-icon-button",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./icon-button.component.html",
    styleUrls: ["./icon-button.component.scss"],
})
export class IconButtonComponent {
    @Input() type: "primary" | "floating" = "primary";
    @Input() size: "small" | "" = "";
    @Input() buttonIcon: string = "";
    @Output() clicked = new EventEmitter<void>();

    onClick() {
        this.clicked.emit();
    }

    get buttonClasses() {
        return {
            "icon-btn": true,
            "primary-btn": this.type === "primary",
            "floating-btn": this.type === "floating",
            "small-btn": this.size === "small",
        };
    }
}
